// Auto-generated icon module
const svg = `<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
	<path d="M12,9.2v5.6c0,0.6-0.5,1-1,1c-0.3,0-0.5-0.1-0.7-0.3L6.8,12l3.5-3.5c0.4-0.4,1-0.4,1.4,0C11.9,8.7,12,8.9,12,9.2z" />
</svg>
`;

export { svg as default };
//# sourceMappingURL=it-arrow-left-triangle-IBF7HkHH.js.map
